module.exports = __webpack_public_path__ + "img/coupon.32fc3ac9.png";